var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#09101A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.50012C5.00007 7.60464 5.89547 8.5 7 8.5C8.10457 8.5 9 7.60457 9 6.5C9 6.48274 8.99978 6.46553 8.99935 6.44838C8.99542 6.29393 8.97399 6.14383 8.93696 6H8.93699C8.71497 5.13739 7.93192 4.5 7 4.5C6.06808 4.5 5.28503 5.13739 5.06301 6H5.06304C5.02189 6.15985 5 6.32743 5 6.50012ZM7 9.5C8.4865 9.5 9.72048 8.41886 9.95852 7H17.5C17.7761 7 18 6.77614 18 6.5C18 6.22386 17.7761 6 17.5 6H9.95852C9.72048 4.58114 8.4865 3.5 7 3.5C5.5135 3.5 4.27952 4.58114 4.04148 6H2.5C2.22386 6 2 6.22386 2 6.5C2 6.77614 2.22386 7 2.5 7H4.04148C4.27952 8.41886 5.5135 9.5 7 9.5ZM14.937 14C14.9781 13.8402 15 13.6726 15 13.5C15 13.3274 14.9781 13.1598 14.937 13C14.715 12.1374 13.9319 11.5 13 11.5C12.0681 11.5 11.285 12.1374 11.063 13C11.0219 13.1598 11 13.3274 11 13.5C11 13.6726 11.0219 13.8402 11.063 14C11.285 14.8626 12.0681 15.5 13 15.5C13.9319 15.5 14.715 14.8626 14.937 14ZM10.0415 13H2.5C2.22386 13 2 13.2239 2 13.5C2 13.7761 2.22386 14 2.5 14H10.0415C10.2795 15.4189 11.5135 16.5 13 16.5C14.4865 16.5 15.7205 15.4189 15.9585 14H17.5C17.7761 14 18 13.7761 18 13.5C18 13.2239 17.7761 13 17.5 13H15.9585C15.7205 11.5811 14.4865 10.5 13 10.5C11.5135 10.5 10.2795 11.5811 10.0415 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.16940c7d4534acc603f6aca74a66a2f3.svg";
export { ForwardRef as ReactComponent };